import React from 'react';
import { connect } from 'react-redux';
import { resetPassword } from './redux/reduxApi';
import { closeModal } from '../../app/modals/redux/modalActions';
import MResetPasswordForm from './MResetPasswordForm';
import useScreenWidth from '../../app/common/helpers/useScreenWidth';
import Modal from '../../ui/Modal';

const actions = {
  closeModal,
  resetPassword,
};

function ModalResetPassword({ data, closeModal, resetPassword }) {
  const auth = data.auth;
  const history = data.history;
  const item = data.item;
  if (item?.roles === 'SA') {
    closeModal();
  }
  const screenWidth = useScreenWidth();
  
  return (
    
    <Modal
      variant='info'
      label='Reset Password'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
     <MResetPasswordForm
          auth={auth}
          history={history}
          initialValues={item}
          resetPassword={resetPassword}
          closeModal={closeModal}
        />
    </Modal>
  )
}

export default connect(null, actions)(ModalResetPassword);
